import { Link } from "react-router-dom";

// Shared "Vendor" cell - vendor code linked to the vendor detail page.
export const VendorCodeCell = ({ vendorId }) =>
  vendorId ? (
    <Link
      to={`/vendors/${vendorId}`}
      className="text-brand-600 hover:text-brand-800 underline font-medium"
    >
      {`VDR-${String(vendorId).padStart(3, "0")}`}
    </Link>
  ) : (
    "—"
  );

// Generic aggregate table. `columns` is [{ header, render(row) }].
const SystemValueTable = ({ columns, rows = [], emptyText }) => (
  <div className="w-full bg-white shadow rounded-lg overflow-hidden">
    <div className="max-h-[600px] overflow-y-auto overflow-x-auto">
      <table className="w-full table-auto border-collapse min-w-[700px]">
        <thead className="sticky top-0 z-10">
          <tr className="bg-white border-b text-[10px] tracking-widest text-gray-500 uppercase">
            {columns.map((c) => (
              <th
                key={c.header}
                className="px-3 py-2 text-center font-semibold whitespace-nowrap"
              >
                {c.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td
                colSpan={columns.length}
                className="py-10 text-center text-gray-400 text-xs"
              >
                {emptyText || "No records found."}
              </td>
            </tr>
          ) : (
            rows.map((row, i) => (
              <tr
                key={row.id ?? i}
                className={`${
                  i % 2 === 0 ? "bg-gray-50" : "bg-white"
                } hover:bg-brand-50 transition-colors`}
              >
                {columns.map((c) => (
                  <td
                    key={c.header}
                    className="px-3 py-2 text-xs whitespace-nowrap text-center text-gray-700"
                  >
                    {c.render(row)}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  </div>
);

export default SystemValueTable;
